<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="1000" >
      <template v-slot:activator="{ on }">
        <v-btn class="red darken-4" dark v-on="on"><img src="@/assets/medal.png"> Certificate</v-btn>
      </template>
      <v-card>
        <img
          class="cert"
          src="../assets/CERTIFICATE_LANDING_PAGE_D969PU3DLF52.jpeg"
        />
        <img
          class="cert"
          src="../assets/CERTIFICATE_LANDING_PAGE_PQKWVR8973BE.jpeg"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {};
</script>

<style scope>
.cert {
  min-width: 500px;
  width: 500px;
  padding: 10px;
}
</style>
